<template>
  <div class="c-my-calendar">
    <div v-if="isOpen" class="invisible-close" @click="isOpen = !isOpen" />
    <div class="date-place" @click="isOpen = !isOpen">
      <span>{{ dateForView }}</span>
    </div>

    <div v-if="isOpen" class="calendar">
      <div class="top">
        <div class="dec" @click="decrease">&#9660;</div>
        <div class="date"> {{ months[month] }} {{ year }} </div>
        <div class="inc" @click="increase">&#9660;</div>
      </div>
      <div class="header">
        <table>
          <tr>
            <th v-for="(d, index) in day" :key="index" class="week-day">{{ d }}</th>
          </tr>
        </table>
      </div>
      <div class="table-wrapper">
        <table class="calendar-table">
          <tr v-for="(week, index) in calendar()" :key="index" class="week">
            <td @click="chooseDay(week[1]?.index)">
              <div class="number" :class="{'active': compareDate(week[1]?.index), 'selectable': disableDate((week[1]?.index))}">
                {{ week[1]?.index }}
              </div>
            </td>
            <td @click="chooseDay(week[2]?.index)">
              <div class="number" :class="{'active': compareDate(week[2]?.index), 'selectable': disableDate((week[2]?.index))}">
                {{ week[2]?.index }}
              </div>
            </td>
            <td @click="chooseDay(week[3]?.index)">
              <div class="number" :class="{'active': compareDate(week[3]?.index), 'selectable': disableDate((week[3]?.index))}" >
                {{ week[3]?.index }}
              </div>
            </td>
            <td @click="chooseDay(week[4]?.index)">
              <div class="number" :class="{'active': compareDate(week[4]?.index), 'selectable': disableDate((week[4]?.index))}">
                {{ week[4]?.index }}
              </div>
            </td>
            <td @click="chooseDay(week[5]?.index)">
              <div class="number" :class="{'active': compareDate(week[5]?.index), 'selectable': disableDate((week[5]?.index))}" >
                {{ week[5]?.index }}
              </div>
            </td>
            <td @click="chooseDay(week[6]?.index)">
              <div class="number" :class="{'active': compareDate(week[6]?.index), 'selectable': disableDate((week[6]?.index))}">
                {{ week[6]?.index }}
              </div>
            </td>
            <td @click="chooseDay(week[0]?.index)">
              <div class="number" :class="{'active': compareDate(week[0]?.index), 'selectable': disableDate((week[0]?.index))}" >
                {{ week[0]?.index }}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CMyCalendar',
  props: {
    date: {
      type: Date,
      default: () => new Date(),
    },
    fromDate: {
      type: Date,
    },
    toDate: {
      type: Date,
    },
  },
  data() {
    return {
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      localeDay: {
        ru: [ 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс', ],
        kz: [ 'Дс', 'Сс', 'Ср', 'Бс', 'Жм', 'Сн', 'Жс', ],
      },
      dateForView: '',
      day: [],
      cDate: new Date,
      localeMonths: {
        ru: [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь', ],
        kz: [ 'Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым', 'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан', ],
      },
      months: [],
      dlast: new Date(this.year, this.month + 1, 0).getDate(),
      isOpen: false,
    }
  },
  watch: {
    cDate() {
      this.updateView()
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const lang = $app.store.getter('app.lang')
      this.months = this.localeMonths[lang]
      this.day = this.localeDay[lang]
      this.cDate = this.date
      this.month = this.cDate.getMonth()
      this.year = this.cDate.getFullYear()
      this.updateView()
    },
    updateView() {
      this.dateForView = (this.cDate.getDate() <= 9 ? '0'+this.cDate.getDate(): this.cDate.getDate()) +
          ' '+ this.months[this.month].substr(0, 3) +'. '+ this.year
    },
    chooseDay(day) {
      if (this.fromDate) {
        if (this.fromDate> new Date(this.year, this.month, day)) {
          return false
        }
      }
      if (this.toDate) {
        if (this.toDate< new Date(this.year, this.month, day)) {
          return false
        }
      }
      if (day) {
        this.cDate = new Date(this.year, this.month, day)
        this.$emit('update:value', new Date(this.year, this.month, day))
        this.$emit('change')
        this.isOpen = false
      }
    },
    compareDate(day) {
      if ($app.date.format(this.cDate, 'date') === $app.date.format(new Date(this.year, this.month, day), 'date')) {
        return true
      } else {
        return false
      }
    },
    disableDate(day) {
      if ($app.date.format(this.cDate, 'date') === $app.date.format(new Date(this.year, this.month, day), 'date')) {
        return false
      }
      if (this.toDate) {
        return $app.date.format(this.toDate, 'date') > $app.date.format(new Date(this.year, this.month, day), 'date')
      } if (this.fromDate) {
        return $app.date.format(this.fromDate, 'date') < $app.date.format(new Date(this.year, this.month, day), 'date')
      }
    },
    calendar: function() {
      let weeks = {}
      let week = 0
      let days = {}
      const dlast = new Date(this.year, this.month + 1, 0).getDate()

      for (let i = 1; i <= dlast; i++) {
        days = {
          ...days,
          [new Date(this.year, this.month, i).getDay()]: { index: i, },
        }
        if (new Date(this.year, this.month, i).getDay() === 0) {
          weeks = {
            ...weeks,
            [week]: days,
          }
          week+=1
          days = {}
        }
      }
      weeks = {
        ...weeks,
        [week]: days,
      }
      return weeks
    },
    decrease() {
      this.month--
      if (this.month < 0) {
        this.month = 12
        this.month--
        this.year--
      }
    },
    increase() {
      this.month++
      if (this.month > 11) {
        this.month = -1
        this.month++
        this.year++
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-my-calendar {
  margin-top: 0;

  .invisible-close {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(4px);
    z-index: 9;
    animation: fadeIn 0.3s ease;
  }

  .date-place {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 44px;
    font-size: 14px;
    font-weight: 500;
    color: #424242;
    background-color: #f7f8fa;
    border-radius: 8px;
    padding: 0 14px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: #1976D2;
      box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
    }

    &::before {
      content: '';
      width: 16px;
      height: 16px;
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='2' y='3' width='12' height='11' rx='2' stroke='%231976D2' stroke-width='1.5'/%3E%3Cpath d='M5 1V4M11 1V4M2 6H14' stroke='%231976D2' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  .calendar {
    min-height: 360px;
    max-width: 400px;
    margin: 0 auto;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    background-color: white;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 50%;
    margin-top: -200px;
    z-index: 10;
    animation: slideUp 0.3s ease-out;

    @media (max-width: 480px) {
      left: 20px;
      right: 20px;
      transform: none;
      max-width: none;
    }

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 16px 16px 0 0;
      padding: 20px 24px;
      background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);

      .dec, .inc {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 8px;
        color: white;
        font-size: 18px;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(255, 255, 255, 0.25);
        }

        &:active {
          transform: scale(0.95);
        }
      }

      .dec {
        transform: rotate(90deg);
      }

      .inc {
        transform: rotate(-90deg);
      }

      .date {
        color: white;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.3px;
      }
    }

    .header {
      background-color: #F5F5F5;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 0;

      th {
        padding: 8px;
        width: 50px;
        height: 22px;
        color: #757575;
        font-size: 13px;
        font-weight: 600;
        text-transform: uppercase;
      }
    }

    .table-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px 12px 20px;
      background: white;
      border-radius: 0 0 16px 16px;
    }

    .calendar-table {
      border-collapse: collapse;

      td {
        padding: 4px;
        width: 50px;
        height: 44px;

        .number {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          font-size: 14px;
          font-weight: 500;
          color: #424242;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;

          &:hover:not(.active):not(.selectable) {
            background: #F5F5F5;
          }

          &.active {
            color: white;
            background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
            box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
            font-weight: 600;
          }

          &.selectable {
            color: white;
            background: linear-gradient(135deg, #42A5F5 0%, #1E88E5 100%);
            box-shadow: 0 2px 8px rgba(66, 165, 245, 0.3);
            font-weight: 600;
          }

          &.disabled {
            color: #BDBDBD;
            cursor: not-allowed;

            &:hover {
              background: transparent;
            }
          }
        }
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
</style>
